import "./sprinkles.css.ts.vanilla.css-mistica.js";
import { createSprinkles as a } from "@vanilla-extract/sprinkles/createRuntimeSprinkles";
var s = a({
    conditions: void 0,
    styles: {
        position: {
            values: {
                relative: {
                    defaultClass: "_1y2v1nfaz"
                },
                absolute: {
                    defaultClass: "_1y2v1nfb0"
                },
                fixed: {
                    defaultClass: "_1y2v1nfb1"
                },
                static: {
                    defaultClass: "_1y2v1nfb2"
                },
                sticky: {
                    defaultClass: "_1y2v1nfb3"
                }
            }
        },
        display: {
            values: {
                none: {
                    defaultClass: "_1y2v1nfb4"
                },
                flex: {
                    defaultClass: "_1y2v1nfb5"
                },
                "inline-flex": {
                    defaultClass: "_1y2v1nfb6"
                },
                block: {
                    defaultClass: "_1y2v1nfb7"
                },
                inline: {
                    defaultClass: "_1y2v1nfb8"
                },
                "inline-block": {
                    defaultClass: "_1y2v1nfb9"
                }
            }
        },
        flexDirection: {
            values: {
                row: {
                    defaultClass: "_1y2v1nfba"
                },
                column: {
                    defaultClass: "_1y2v1nfbb"
                }
            }
        },
        justifyContent: {
            values: {
                stretch: {
                    defaultClass: "_1y2v1nfbc"
                },
                "flex-start": {
                    defaultClass: "_1y2v1nfbd"
                },
                center: {
                    defaultClass: "_1y2v1nfbe"
                },
                "flex-end": {
                    defaultClass: "_1y2v1nfbf"
                },
                "space-around": {
                    defaultClass: "_1y2v1nfbg"
                },
                "space-between": {
                    defaultClass: "_1y2v1nfbh"
                }
            }
        },
        alignItems: {
            values: {
                stretch: {
                    defaultClass: "_1y2v1nfbi"
                },
                "flex-start": {
                    defaultClass: "_1y2v1nfbj"
                },
                center: {
                    defaultClass: "_1y2v1nfbk"
                },
                "flex-end": {
                    defaultClass: "_1y2v1nfbl"
                },
                baseline: {
                    defaultClass: "_1y2v1nfbm"
                }
            }
        },
        flexShrink: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfbn"
                },
                1: {
                    defaultClass: "_1y2v1nfbo"
                }
            }
        },
        flexGrow: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfbp"
                },
                1: {
                    defaultClass: "_1y2v1nfbq"
                }
            }
        },
        flex: {
            values: {
                1: {
                    defaultClass: "_1y2v1nfbr"
                }
            }
        },
        width: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfbu"
                },
                2: {
                    defaultClass: "_1y2v1nfbv"
                },
                4: {
                    defaultClass: "_1y2v1nfbw"
                },
                8: {
                    defaultClass: "_1y2v1nfbx"
                },
                12: {
                    defaultClass: "_1y2v1nfby"
                },
                16: {
                    defaultClass: "_1y2v1nfbz"
                },
                20: {
                    defaultClass: "_1y2v1nfc0"
                },
                24: {
                    defaultClass: "_1y2v1nfc1"
                },
                32: {
                    defaultClass: "_1y2v1nfc2"
                },
                40: {
                    defaultClass: "_1y2v1nfc3"
                },
                48: {
                    defaultClass: "_1y2v1nfc4"
                },
                56: {
                    defaultClass: "_1y2v1nfc5"
                },
                64: {
                    defaultClass: "_1y2v1nfc6"
                },
                72: {
                    defaultClass: "_1y2v1nfc7"
                },
                80: {
                    defaultClass: "_1y2v1nfc8"
                },
                "100%": {
                    defaultClass: "_1y2v1nfbs"
                },
                auto: {
                    defaultClass: "_1y2v1nfbt"
                }
            }
        },
        height: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfca"
                },
                2: {
                    defaultClass: "_1y2v1nfcb"
                },
                4: {
                    defaultClass: "_1y2v1nfcc"
                },
                8: {
                    defaultClass: "_1y2v1nfcd"
                },
                12: {
                    defaultClass: "_1y2v1nfce"
                },
                16: {
                    defaultClass: "_1y2v1nfcf"
                },
                20: {
                    defaultClass: "_1y2v1nfcg"
                },
                24: {
                    defaultClass: "_1y2v1nfch"
                },
                32: {
                    defaultClass: "_1y2v1nfci"
                },
                40: {
                    defaultClass: "_1y2v1nfcj"
                },
                48: {
                    defaultClass: "_1y2v1nfck"
                },
                56: {
                    defaultClass: "_1y2v1nfcl"
                },
                64: {
                    defaultClass: "_1y2v1nfcm"
                },
                72: {
                    defaultClass: "_1y2v1nfcn"
                },
                80: {
                    defaultClass: "_1y2v1nfco"
                },
                "100%": {
                    defaultClass: "_1y2v1nfc9"
                }
            }
        },
        minWidth: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfcq"
                },
                2: {
                    defaultClass: "_1y2v1nfcr"
                },
                4: {
                    defaultClass: "_1y2v1nfcs"
                },
                8: {
                    defaultClass: "_1y2v1nfct"
                },
                12: {
                    defaultClass: "_1y2v1nfcu"
                },
                16: {
                    defaultClass: "_1y2v1nfcv"
                },
                20: {
                    defaultClass: "_1y2v1nfcw"
                },
                24: {
                    defaultClass: "_1y2v1nfcx"
                },
                32: {
                    defaultClass: "_1y2v1nfcy"
                },
                40: {
                    defaultClass: "_1y2v1nfcz"
                },
                48: {
                    defaultClass: "_1y2v1nfd0"
                },
                56: {
                    defaultClass: "_1y2v1nfd1"
                },
                64: {
                    defaultClass: "_1y2v1nfd2"
                },
                72: {
                    defaultClass: "_1y2v1nfd3"
                },
                80: {
                    defaultClass: "_1y2v1nfd4"
                },
                "100%": {
                    defaultClass: "_1y2v1nfcp"
                }
            }
        },
        minHeight: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfd5"
                },
                2: {
                    defaultClass: "_1y2v1nfd6"
                },
                4: {
                    defaultClass: "_1y2v1nfd7"
                },
                8: {
                    defaultClass: "_1y2v1nfd8"
                },
                12: {
                    defaultClass: "_1y2v1nfd9"
                },
                16: {
                    defaultClass: "_1y2v1nfda"
                },
                20: {
                    defaultClass: "_1y2v1nfdb"
                },
                24: {
                    defaultClass: "_1y2v1nfdc"
                },
                32: {
                    defaultClass: "_1y2v1nfdd"
                },
                40: {
                    defaultClass: "_1y2v1nfde"
                },
                48: {
                    defaultClass: "_1y2v1nfdf"
                },
                56: {
                    defaultClass: "_1y2v1nfdg"
                },
                64: {
                    defaultClass: "_1y2v1nfdh"
                },
                72: {
                    defaultClass: "_1y2v1nfdi"
                },
                80: {
                    defaultClass: "_1y2v1nfdj"
                }
            }
        },
        maxWidth: {
            values: {
                "100%": {
                    defaultClass: "_1y2v1nfdk"
                }
            }
        },
        maxHeight: {
            values: {
                "100%": {
                    defaultClass: "_1y2v1nfdl"
                }
            }
        },
        border: {
            values: {
                regular: {
                    defaultClass: "_1y2v1nfdm"
                },
                none: {
                    defaultClass: "_1y2v1nfdn"
                }
            }
        },
        borderRadius: {
            values: {
                2: {
                    defaultClass: "_1y2v1nfdp"
                },
                4: {
                    defaultClass: "_1y2v1nfdq"
                },
                8: {
                    defaultClass: "_1y2v1nfdr"
                },
                16: {
                    defaultClass: "_1y2v1nfds"
                },
                20: {
                    defaultClass: "_1y2v1nfdt"
                },
                "50%": {
                    defaultClass: "_1y2v1nfdo"
                },
                "var(--_1vqcj1i5u)": {
                    defaultClass: "_1y2v1nfdu"
                },
                "var(--_1vqcj1i5v)": {
                    defaultClass: "_1y2v1nfdv"
                },
                "var(--_1vqcj1i5w)": {
                    defaultClass: "_1y2v1nfdw"
                },
                "var(--_1vqcj1i5x)": {
                    defaultClass: "_1y2v1nfdx"
                },
                "var(--_1vqcj1i5y)": {
                    defaultClass: "_1y2v1nfdy"
                },
                "var(--_1vqcj1i5z)": {
                    defaultClass: "_1y2v1nfdz"
                },
                "var(--_1vqcj1i60)": {
                    defaultClass: "_1y2v1nfe0"
                },
                "var(--_1vqcj1i61)": {
                    defaultClass: "_1y2v1nfe1"
                },
                "var(--_1vqcj1i62)": {
                    defaultClass: "_1y2v1nfe2"
                },
                "var(--_1vqcj1i63)": {
                    defaultClass: "_1y2v1nfe3"
                }
            }
        },
        cursor: {
            values: {
                pointer: {
                    defaultClass: "_1y2v1nfe4"
                }
            }
        },
        overflow: {
            values: {
                hidden: {
                    defaultClass: "_1y2v1nfe5"
                },
                visible: {
                    defaultClass: "_1y2v1nfe6"
                },
                auto: {
                    defaultClass: "_1y2v1nfe7"
                }
            }
        },
        overflowY: {
            values: {
                hidden: {
                    defaultClass: "_1y2v1nfe8"
                },
                visible: {
                    defaultClass: "_1y2v1nfe9"
                },
                auto: {
                    defaultClass: "_1y2v1nfea"
                }
            }
        },
        top: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfeb"
                },
                2: {
                    defaultClass: "_1y2v1nfec"
                },
                4: {
                    defaultClass: "_1y2v1nfed"
                },
                8: {
                    defaultClass: "_1y2v1nfee"
                },
                12: {
                    defaultClass: "_1y2v1nfef"
                },
                16: {
                    defaultClass: "_1y2v1nfeg"
                },
                20: {
                    defaultClass: "_1y2v1nfeh"
                },
                24: {
                    defaultClass: "_1y2v1nfei"
                },
                32: {
                    defaultClass: "_1y2v1nfej"
                },
                40: {
                    defaultClass: "_1y2v1nfek"
                },
                48: {
                    defaultClass: "_1y2v1nfel"
                },
                56: {
                    defaultClass: "_1y2v1nfem"
                },
                64: {
                    defaultClass: "_1y2v1nfen"
                },
                72: {
                    defaultClass: "_1y2v1nfeo"
                },
                80: {
                    defaultClass: "_1y2v1nfep"
                }
            }
        },
        left: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfeq"
                },
                2: {
                    defaultClass: "_1y2v1nfer"
                },
                4: {
                    defaultClass: "_1y2v1nfes"
                },
                8: {
                    defaultClass: "_1y2v1nfet"
                },
                12: {
                    defaultClass: "_1y2v1nfeu"
                },
                16: {
                    defaultClass: "_1y2v1nfev"
                },
                20: {
                    defaultClass: "_1y2v1nfew"
                },
                24: {
                    defaultClass: "_1y2v1nfex"
                },
                32: {
                    defaultClass: "_1y2v1nfey"
                },
                40: {
                    defaultClass: "_1y2v1nfez"
                },
                48: {
                    defaultClass: "_1y2v1nff0"
                },
                56: {
                    defaultClass: "_1y2v1nff1"
                },
                64: {
                    defaultClass: "_1y2v1nff2"
                },
                72: {
                    defaultClass: "_1y2v1nff3"
                },
                80: {
                    defaultClass: "_1y2v1nff4"
                }
            }
        },
        right: {
            values: {
                0: {
                    defaultClass: "_1y2v1nff5"
                },
                2: {
                    defaultClass: "_1y2v1nff6"
                },
                4: {
                    defaultClass: "_1y2v1nff7"
                },
                8: {
                    defaultClass: "_1y2v1nff8"
                },
                12: {
                    defaultClass: "_1y2v1nff9"
                },
                16: {
                    defaultClass: "_1y2v1nffa"
                },
                20: {
                    defaultClass: "_1y2v1nffb"
                },
                24: {
                    defaultClass: "_1y2v1nffc"
                },
                32: {
                    defaultClass: "_1y2v1nffd"
                },
                40: {
                    defaultClass: "_1y2v1nffe"
                },
                48: {
                    defaultClass: "_1y2v1nfff"
                },
                56: {
                    defaultClass: "_1y2v1nffg"
                },
                64: {
                    defaultClass: "_1y2v1nffh"
                },
                72: {
                    defaultClass: "_1y2v1nffi"
                },
                80: {
                    defaultClass: "_1y2v1nffj"
                }
            }
        },
        bottom: {
            values: {
                0: {
                    defaultClass: "_1y2v1nffk"
                },
                2: {
                    defaultClass: "_1y2v1nffl"
                },
                4: {
                    defaultClass: "_1y2v1nffm"
                },
                8: {
                    defaultClass: "_1y2v1nffn"
                },
                12: {
                    defaultClass: "_1y2v1nffo"
                },
                16: {
                    defaultClass: "_1y2v1nffp"
                },
                20: {
                    defaultClass: "_1y2v1nffq"
                },
                24: {
                    defaultClass: "_1y2v1nffr"
                },
                32: {
                    defaultClass: "_1y2v1nffs"
                },
                40: {
                    defaultClass: "_1y2v1nfft"
                },
                48: {
                    defaultClass: "_1y2v1nffu"
                },
                56: {
                    defaultClass: "_1y2v1nffv"
                },
                64: {
                    defaultClass: "_1y2v1nffw"
                },
                72: {
                    defaultClass: "_1y2v1nffx"
                },
                80: {
                    defaultClass: "_1y2v1nffy"
                }
            }
        },
        objectFit: {
            values: {
                cover: {
                    defaultClass: "_1y2v1nffz"
                }
            }
        }
    }
}, {
    conditions: {
        defaultCondition: "mobile",
        conditionNames: [
            "mobile",
            "tablet",
            "desktop"
        ],
        responsiveArray: void 0
    },
    styles: {
        padding: {
            mappings: [
                "paddingTop",
                "paddingBottom",
                "paddingLeft",
                "paddingRight"
            ]
        },
        paddingX: {
            mappings: [
                "paddingLeft",
                "paddingRight"
            ]
        },
        paddingY: {
            mappings: [
                "paddingTop",
                "paddingBottom"
            ]
        },
        paddingTop: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nf5z",
                        tablet: "_1y2v1nf60",
                        desktop: "_1y2v1nf61"
                    },
                    defaultClass: "_1y2v1nf5z"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nf62",
                        tablet: "_1y2v1nf63",
                        desktop: "_1y2v1nf64"
                    },
                    defaultClass: "_1y2v1nf62"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nf65",
                        tablet: "_1y2v1nf66",
                        desktop: "_1y2v1nf67"
                    },
                    defaultClass: "_1y2v1nf65"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nf68",
                        tablet: "_1y2v1nf69",
                        desktop: "_1y2v1nf6a"
                    },
                    defaultClass: "_1y2v1nf68"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nf6b",
                        tablet: "_1y2v1nf6c",
                        desktop: "_1y2v1nf6d"
                    },
                    defaultClass: "_1y2v1nf6b"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nf6e",
                        tablet: "_1y2v1nf6f",
                        desktop: "_1y2v1nf6g"
                    },
                    defaultClass: "_1y2v1nf6e"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nf6h",
                        tablet: "_1y2v1nf6i",
                        desktop: "_1y2v1nf6j"
                    },
                    defaultClass: "_1y2v1nf6h"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nf6k",
                        tablet: "_1y2v1nf6l",
                        desktop: "_1y2v1nf6m"
                    },
                    defaultClass: "_1y2v1nf6k"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nf6n",
                        tablet: "_1y2v1nf6o",
                        desktop: "_1y2v1nf6p"
                    },
                    defaultClass: "_1y2v1nf6n"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nf6q",
                        tablet: "_1y2v1nf6r",
                        desktop: "_1y2v1nf6s"
                    },
                    defaultClass: "_1y2v1nf6q"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nf6t",
                        tablet: "_1y2v1nf6u",
                        desktop: "_1y2v1nf6v"
                    },
                    defaultClass: "_1y2v1nf6t"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nf6w",
                        tablet: "_1y2v1nf6x",
                        desktop: "_1y2v1nf6y"
                    },
                    defaultClass: "_1y2v1nf6w"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nf6z",
                        tablet: "_1y2v1nf70",
                        desktop: "_1y2v1nf71"
                    },
                    defaultClass: "_1y2v1nf6z"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nf72",
                        tablet: "_1y2v1nf73",
                        desktop: "_1y2v1nf74"
                    },
                    defaultClass: "_1y2v1nf72"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nf75",
                        tablet: "_1y2v1nf76",
                        desktop: "_1y2v1nf77"
                    },
                    defaultClass: "_1y2v1nf75"
                }
            }
        },
        paddingBottom: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nf78",
                        tablet: "_1y2v1nf79",
                        desktop: "_1y2v1nf7a"
                    },
                    defaultClass: "_1y2v1nf78"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nf7b",
                        tablet: "_1y2v1nf7c",
                        desktop: "_1y2v1nf7d"
                    },
                    defaultClass: "_1y2v1nf7b"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nf7e",
                        tablet: "_1y2v1nf7f",
                        desktop: "_1y2v1nf7g"
                    },
                    defaultClass: "_1y2v1nf7e"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nf7h",
                        tablet: "_1y2v1nf7i",
                        desktop: "_1y2v1nf7j"
                    },
                    defaultClass: "_1y2v1nf7h"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nf7k",
                        tablet: "_1y2v1nf7l",
                        desktop: "_1y2v1nf7m"
                    },
                    defaultClass: "_1y2v1nf7k"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nf7n",
                        tablet: "_1y2v1nf7o",
                        desktop: "_1y2v1nf7p"
                    },
                    defaultClass: "_1y2v1nf7n"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nf7q",
                        tablet: "_1y2v1nf7r",
                        desktop: "_1y2v1nf7s"
                    },
                    defaultClass: "_1y2v1nf7q"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nf7t",
                        tablet: "_1y2v1nf7u",
                        desktop: "_1y2v1nf7v"
                    },
                    defaultClass: "_1y2v1nf7t"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nf7w",
                        tablet: "_1y2v1nf7x",
                        desktop: "_1y2v1nf7y"
                    },
                    defaultClass: "_1y2v1nf7w"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nf7z",
                        tablet: "_1y2v1nf80",
                        desktop: "_1y2v1nf81"
                    },
                    defaultClass: "_1y2v1nf7z"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nf82",
                        tablet: "_1y2v1nf83",
                        desktop: "_1y2v1nf84"
                    },
                    defaultClass: "_1y2v1nf82"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nf85",
                        tablet: "_1y2v1nf86",
                        desktop: "_1y2v1nf87"
                    },
                    defaultClass: "_1y2v1nf85"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nf88",
                        tablet: "_1y2v1nf89",
                        desktop: "_1y2v1nf8a"
                    },
                    defaultClass: "_1y2v1nf88"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nf8b",
                        tablet: "_1y2v1nf8c",
                        desktop: "_1y2v1nf8d"
                    },
                    defaultClass: "_1y2v1nf8b"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nf8e",
                        tablet: "_1y2v1nf8f",
                        desktop: "_1y2v1nf8g"
                    },
                    defaultClass: "_1y2v1nf8e"
                }
            }
        },
        paddingLeft: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nf8h",
                        tablet: "_1y2v1nf8i",
                        desktop: "_1y2v1nf8j"
                    },
                    defaultClass: "_1y2v1nf8h"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nf8k",
                        tablet: "_1y2v1nf8l",
                        desktop: "_1y2v1nf8m"
                    },
                    defaultClass: "_1y2v1nf8k"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nf8n",
                        tablet: "_1y2v1nf8o",
                        desktop: "_1y2v1nf8p"
                    },
                    defaultClass: "_1y2v1nf8n"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nf8q",
                        tablet: "_1y2v1nf8r",
                        desktop: "_1y2v1nf8s"
                    },
                    defaultClass: "_1y2v1nf8q"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nf8t",
                        tablet: "_1y2v1nf8u",
                        desktop: "_1y2v1nf8v"
                    },
                    defaultClass: "_1y2v1nf8t"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nf8w",
                        tablet: "_1y2v1nf8x",
                        desktop: "_1y2v1nf8y"
                    },
                    defaultClass: "_1y2v1nf8w"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nf8z",
                        tablet: "_1y2v1nf90",
                        desktop: "_1y2v1nf91"
                    },
                    defaultClass: "_1y2v1nf8z"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nf92",
                        tablet: "_1y2v1nf93",
                        desktop: "_1y2v1nf94"
                    },
                    defaultClass: "_1y2v1nf92"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nf95",
                        tablet: "_1y2v1nf96",
                        desktop: "_1y2v1nf97"
                    },
                    defaultClass: "_1y2v1nf95"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nf98",
                        tablet: "_1y2v1nf99",
                        desktop: "_1y2v1nf9a"
                    },
                    defaultClass: "_1y2v1nf98"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nf9b",
                        tablet: "_1y2v1nf9c",
                        desktop: "_1y2v1nf9d"
                    },
                    defaultClass: "_1y2v1nf9b"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nf9e",
                        tablet: "_1y2v1nf9f",
                        desktop: "_1y2v1nf9g"
                    },
                    defaultClass: "_1y2v1nf9e"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nf9h",
                        tablet: "_1y2v1nf9i",
                        desktop: "_1y2v1nf9j"
                    },
                    defaultClass: "_1y2v1nf9h"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nf9k",
                        tablet: "_1y2v1nf9l",
                        desktop: "_1y2v1nf9m"
                    },
                    defaultClass: "_1y2v1nf9k"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nf9n",
                        tablet: "_1y2v1nf9o",
                        desktop: "_1y2v1nf9p"
                    },
                    defaultClass: "_1y2v1nf9n"
                }
            }
        },
        paddingRight: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nf9q",
                        tablet: "_1y2v1nf9r",
                        desktop: "_1y2v1nf9s"
                    },
                    defaultClass: "_1y2v1nf9q"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nf9t",
                        tablet: "_1y2v1nf9u",
                        desktop: "_1y2v1nf9v"
                    },
                    defaultClass: "_1y2v1nf9t"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nf9w",
                        tablet: "_1y2v1nf9x",
                        desktop: "_1y2v1nf9y"
                    },
                    defaultClass: "_1y2v1nf9w"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nf9z",
                        tablet: "_1y2v1nfa0",
                        desktop: "_1y2v1nfa1"
                    },
                    defaultClass: "_1y2v1nf9z"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nfa2",
                        tablet: "_1y2v1nfa3",
                        desktop: "_1y2v1nfa4"
                    },
                    defaultClass: "_1y2v1nfa2"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nfa5",
                        tablet: "_1y2v1nfa6",
                        desktop: "_1y2v1nfa7"
                    },
                    defaultClass: "_1y2v1nfa5"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nfa8",
                        tablet: "_1y2v1nfa9",
                        desktop: "_1y2v1nfaa"
                    },
                    defaultClass: "_1y2v1nfa8"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nfab",
                        tablet: "_1y2v1nfac",
                        desktop: "_1y2v1nfad"
                    },
                    defaultClass: "_1y2v1nfab"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nfae",
                        tablet: "_1y2v1nfaf",
                        desktop: "_1y2v1nfag"
                    },
                    defaultClass: "_1y2v1nfae"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nfah",
                        tablet: "_1y2v1nfai",
                        desktop: "_1y2v1nfaj"
                    },
                    defaultClass: "_1y2v1nfah"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nfak",
                        tablet: "_1y2v1nfal",
                        desktop: "_1y2v1nfam"
                    },
                    defaultClass: "_1y2v1nfak"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nfan",
                        tablet: "_1y2v1nfao",
                        desktop: "_1y2v1nfap"
                    },
                    defaultClass: "_1y2v1nfan"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nfaq",
                        tablet: "_1y2v1nfar",
                        desktop: "_1y2v1nfas"
                    },
                    defaultClass: "_1y2v1nfaq"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nfat",
                        tablet: "_1y2v1nfau",
                        desktop: "_1y2v1nfav"
                    },
                    defaultClass: "_1y2v1nfat"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nfaw",
                        tablet: "_1y2v1nfax",
                        desktop: "_1y2v1nfay"
                    },
                    defaultClass: "_1y2v1nfaw"
                }
            }
        }
    }
}, {
    conditions: void 0,
    styles: {
        color: {
            values: {
                "var(--_1vqcj1i0)": {
                    defaultClass: "_1y2v1nf0"
                },
                "var(--_1vqcj1i1)": {
                    defaultClass: "_1y2v1nf1"
                },
                "var(--_1vqcj1i2)": {
                    defaultClass: "_1y2v1nf2"
                },
                "var(--_1vqcj1i3)": {
                    defaultClass: "_1y2v1nf3"
                },
                "var(--_1vqcj1i4)": {
                    defaultClass: "_1y2v1nf4"
                },
                "var(--_1vqcj1i5)": {
                    defaultClass: "_1y2v1nf5"
                },
                "var(--_1vqcj1i6)": {
                    defaultClass: "_1y2v1nf6"
                },
                "var(--_1vqcj1i7)": {
                    defaultClass: "_1y2v1nf7"
                },
                "var(--_1vqcj1i8)": {
                    defaultClass: "_1y2v1nf8"
                },
                "var(--_1vqcj1i9)": {
                    defaultClass: "_1y2v1nf9"
                },
                "var(--_1vqcj1ia)": {
                    defaultClass: "_1y2v1nfa"
                },
                "var(--_1vqcj1ib)": {
                    defaultClass: "_1y2v1nfb"
                },
                "var(--_1vqcj1ic)": {
                    defaultClass: "_1y2v1nfc"
                },
                "var(--_1vqcj1id)": {
                    defaultClass: "_1y2v1nfd"
                },
                "var(--_1vqcj1ie)": {
                    defaultClass: "_1y2v1nfe"
                },
                "var(--_1vqcj1if)": {
                    defaultClass: "_1y2v1nff"
                },
                "var(--_1vqcj1ig)": {
                    defaultClass: "_1y2v1nfg"
                },
                "var(--_1vqcj1ih)": {
                    defaultClass: "_1y2v1nfh"
                },
                "var(--_1vqcj1ii)": {
                    defaultClass: "_1y2v1nfi"
                },
                "var(--_1vqcj1ij)": {
                    defaultClass: "_1y2v1nfj"
                },
                "var(--_1vqcj1ik)": {
                    defaultClass: "_1y2v1nfk"
                },
                "var(--_1vqcj1il)": {
                    defaultClass: "_1y2v1nfl"
                },
                "var(--_1vqcj1im)": {
                    defaultClass: "_1y2v1nfm"
                },
                "var(--_1vqcj1in)": {
                    defaultClass: "_1y2v1nfn"
                },
                "var(--_1vqcj1io)": {
                    defaultClass: "_1y2v1nfo"
                },
                "var(--_1vqcj1ip)": {
                    defaultClass: "_1y2v1nfp"
                },
                "var(--_1vqcj1iq)": {
                    defaultClass: "_1y2v1nfq"
                },
                "var(--_1vqcj1ir)": {
                    defaultClass: "_1y2v1nfr"
                },
                "var(--_1vqcj1is)": {
                    defaultClass: "_1y2v1nfs"
                },
                "var(--_1vqcj1it)": {
                    defaultClass: "_1y2v1nft"
                },
                "var(--_1vqcj1iu)": {
                    defaultClass: "_1y2v1nfu"
                },
                "var(--_1vqcj1iv)": {
                    defaultClass: "_1y2v1nfv"
                },
                "var(--_1vqcj1iw)": {
                    defaultClass: "_1y2v1nfw"
                },
                "var(--_1vqcj1ix)": {
                    defaultClass: "_1y2v1nfx"
                },
                "var(--_1vqcj1iy)": {
                    defaultClass: "_1y2v1nfy"
                },
                "var(--_1vqcj1iz)": {
                    defaultClass: "_1y2v1nfz"
                },
                "var(--_1vqcj1i10)": {
                    defaultClass: "_1y2v1nf10"
                },
                "var(--_1vqcj1i11)": {
                    defaultClass: "_1y2v1nf11"
                },
                "var(--_1vqcj1i12)": {
                    defaultClass: "_1y2v1nf12"
                },
                "var(--_1vqcj1i13)": {
                    defaultClass: "_1y2v1nf13"
                },
                "var(--_1vqcj1i14)": {
                    defaultClass: "_1y2v1nf14"
                },
                "var(--_1vqcj1i15)": {
                    defaultClass: "_1y2v1nf15"
                },
                "var(--_1vqcj1i16)": {
                    defaultClass: "_1y2v1nf16"
                },
                "var(--_1vqcj1i17)": {
                    defaultClass: "_1y2v1nf17"
                },
                "var(--_1vqcj1i18)": {
                    defaultClass: "_1y2v1nf18"
                },
                "var(--_1vqcj1i19)": {
                    defaultClass: "_1y2v1nf19"
                },
                "var(--_1vqcj1i1a)": {
                    defaultClass: "_1y2v1nf1a"
                },
                "var(--_1vqcj1i1b)": {
                    defaultClass: "_1y2v1nf1b"
                },
                "var(--_1vqcj1i1c)": {
                    defaultClass: "_1y2v1nf1c"
                },
                "var(--_1vqcj1i1d)": {
                    defaultClass: "_1y2v1nf1d"
                },
                "var(--_1vqcj1i1e)": {
                    defaultClass: "_1y2v1nf1e"
                },
                "var(--_1vqcj1i1f)": {
                    defaultClass: "_1y2v1nf1f"
                },
                "var(--_1vqcj1i1g)": {
                    defaultClass: "_1y2v1nf1g"
                },
                "var(--_1vqcj1i1h)": {
                    defaultClass: "_1y2v1nf1h"
                },
                "var(--_1vqcj1i1i)": {
                    defaultClass: "_1y2v1nf1i"
                },
                "var(--_1vqcj1i1j)": {
                    defaultClass: "_1y2v1nf1j"
                },
                "var(--_1vqcj1i1k)": {
                    defaultClass: "_1y2v1nf1k"
                },
                "var(--_1vqcj1i1l)": {
                    defaultClass: "_1y2v1nf1l"
                },
                "var(--_1vqcj1i1m)": {
                    defaultClass: "_1y2v1nf1m"
                },
                "var(--_1vqcj1i1n)": {
                    defaultClass: "_1y2v1nf1n"
                },
                "var(--_1vqcj1i1o)": {
                    defaultClass: "_1y2v1nf1o"
                },
                "var(--_1vqcj1i1p)": {
                    defaultClass: "_1y2v1nf1p"
                },
                "var(--_1vqcj1i1q)": {
                    defaultClass: "_1y2v1nf1q"
                },
                "var(--_1vqcj1i1r)": {
                    defaultClass: "_1y2v1nf1r"
                },
                "var(--_1vqcj1i1s)": {
                    defaultClass: "_1y2v1nf1s"
                },
                "var(--_1vqcj1i1t)": {
                    defaultClass: "_1y2v1nf1t"
                },
                "var(--_1vqcj1i1u)": {
                    defaultClass: "_1y2v1nf1u"
                },
                "var(--_1vqcj1i1v)": {
                    defaultClass: "_1y2v1nf1v"
                },
                "var(--_1vqcj1i1w)": {
                    defaultClass: "_1y2v1nf1w"
                },
                "var(--_1vqcj1i1x)": {
                    defaultClass: "_1y2v1nf1x"
                },
                "var(--_1vqcj1i1y)": {
                    defaultClass: "_1y2v1nf1y"
                },
                "var(--_1vqcj1i1z)": {
                    defaultClass: "_1y2v1nf1z"
                },
                "var(--_1vqcj1i20)": {
                    defaultClass: "_1y2v1nf20"
                },
                "var(--_1vqcj1i21)": {
                    defaultClass: "_1y2v1nf21"
                },
                "var(--_1vqcj1i22)": {
                    defaultClass: "_1y2v1nf22"
                },
                "var(--_1vqcj1i23)": {
                    defaultClass: "_1y2v1nf23"
                },
                "var(--_1vqcj1i24)": {
                    defaultClass: "_1y2v1nf24"
                },
                "var(--_1vqcj1i25)": {
                    defaultClass: "_1y2v1nf25"
                },
                "var(--_1vqcj1i26)": {
                    defaultClass: "_1y2v1nf26"
                },
                "var(--_1vqcj1i27)": {
                    defaultClass: "_1y2v1nf27"
                },
                "var(--_1vqcj1i28)": {
                    defaultClass: "_1y2v1nf28"
                },
                "var(--_1vqcj1i29)": {
                    defaultClass: "_1y2v1nf29"
                },
                "var(--_1vqcj1i2a)": {
                    defaultClass: "_1y2v1nf2a"
                },
                "var(--_1vqcj1i2b)": {
                    defaultClass: "_1y2v1nf2b"
                },
                "var(--_1vqcj1i2c)": {
                    defaultClass: "_1y2v1nf2c"
                },
                "var(--_1vqcj1i2d)": {
                    defaultClass: "_1y2v1nf2d"
                },
                "var(--_1vqcj1i2e)": {
                    defaultClass: "_1y2v1nf2e"
                },
                "var(--_1vqcj1i2f)": {
                    defaultClass: "_1y2v1nf2f"
                },
                "var(--_1vqcj1i2g)": {
                    defaultClass: "_1y2v1nf2g"
                },
                "var(--_1vqcj1i2h)": {
                    defaultClass: "_1y2v1nf2h"
                },
                "var(--_1vqcj1i2i)": {
                    defaultClass: "_1y2v1nf2i"
                },
                "var(--_1vqcj1i2j)": {
                    defaultClass: "_1y2v1nf2j"
                },
                "var(--_1vqcj1i2k)": {
                    defaultClass: "_1y2v1nf2k"
                },
                "var(--_1vqcj1i2l)": {
                    defaultClass: "_1y2v1nf2l"
                },
                "var(--_1vqcj1i2m)": {
                    defaultClass: "_1y2v1nf2m"
                },
                "var(--_1vqcj1i2n)": {
                    defaultClass: "_1y2v1nf2n"
                },
                "var(--_1vqcj1i2o)": {
                    defaultClass: "_1y2v1nf2o"
                },
                "var(--_1vqcj1i2p)": {
                    defaultClass: "_1y2v1nf2p"
                },
                "var(--_1vqcj1i2q)": {
                    defaultClass: "_1y2v1nf2q"
                },
                "var(--_1vqcj1i2r)": {
                    defaultClass: "_1y2v1nf2r"
                },
                "var(--_1vqcj1i2s)": {
                    defaultClass: "_1y2v1nf2s"
                },
                "var(--_1vqcj1i2t)": {
                    defaultClass: "_1y2v1nf2t"
                },
                "var(--_1vqcj1i2u)": {
                    defaultClass: "_1y2v1nf2u"
                },
                "var(--_1vqcj1i2v)": {
                    defaultClass: "_1y2v1nf2v"
                },
                "var(--_1vqcj1i2w)": {
                    defaultClass: "_1y2v1nf2w"
                },
                transparent: {
                    defaultClass: "_1y2v1nf2x"
                },
                inherit: {
                    defaultClass: "_1y2v1nf2y"
                }
            }
        },
        background: {
            values: {
                "var(--_1vqcj1i0)": {
                    defaultClass: "_1y2v1nf2z"
                },
                "var(--_1vqcj1i1)": {
                    defaultClass: "_1y2v1nf30"
                },
                "var(--_1vqcj1i2)": {
                    defaultClass: "_1y2v1nf31"
                },
                "var(--_1vqcj1i3)": {
                    defaultClass: "_1y2v1nf32"
                },
                "var(--_1vqcj1i4)": {
                    defaultClass: "_1y2v1nf33"
                },
                "var(--_1vqcj1i5)": {
                    defaultClass: "_1y2v1nf34"
                },
                "var(--_1vqcj1i6)": {
                    defaultClass: "_1y2v1nf35"
                },
                "var(--_1vqcj1i7)": {
                    defaultClass: "_1y2v1nf36"
                },
                "var(--_1vqcj1i8)": {
                    defaultClass: "_1y2v1nf37"
                },
                "var(--_1vqcj1i9)": {
                    defaultClass: "_1y2v1nf38"
                },
                "var(--_1vqcj1ia)": {
                    defaultClass: "_1y2v1nf39"
                },
                "var(--_1vqcj1ib)": {
                    defaultClass: "_1y2v1nf3a"
                },
                "var(--_1vqcj1ic)": {
                    defaultClass: "_1y2v1nf3b"
                },
                "var(--_1vqcj1id)": {
                    defaultClass: "_1y2v1nf3c"
                },
                "var(--_1vqcj1ie)": {
                    defaultClass: "_1y2v1nf3d"
                },
                "var(--_1vqcj1if)": {
                    defaultClass: "_1y2v1nf3e"
                },
                "var(--_1vqcj1ig)": {
                    defaultClass: "_1y2v1nf3f"
                },
                "var(--_1vqcj1ih)": {
                    defaultClass: "_1y2v1nf3g"
                },
                "var(--_1vqcj1ii)": {
                    defaultClass: "_1y2v1nf3h"
                },
                "var(--_1vqcj1ij)": {
                    defaultClass: "_1y2v1nf3i"
                },
                "var(--_1vqcj1ik)": {
                    defaultClass: "_1y2v1nf3j"
                },
                "var(--_1vqcj1il)": {
                    defaultClass: "_1y2v1nf3k"
                },
                "var(--_1vqcj1im)": {
                    defaultClass: "_1y2v1nf3l"
                },
                "var(--_1vqcj1in)": {
                    defaultClass: "_1y2v1nf3m"
                },
                "var(--_1vqcj1io)": {
                    defaultClass: "_1y2v1nf3n"
                },
                "var(--_1vqcj1ip)": {
                    defaultClass: "_1y2v1nf3o"
                },
                "var(--_1vqcj1iq)": {
                    defaultClass: "_1y2v1nf3p"
                },
                "var(--_1vqcj1ir)": {
                    defaultClass: "_1y2v1nf3q"
                },
                "var(--_1vqcj1is)": {
                    defaultClass: "_1y2v1nf3r"
                },
                "var(--_1vqcj1it)": {
                    defaultClass: "_1y2v1nf3s"
                },
                "var(--_1vqcj1iu)": {
                    defaultClass: "_1y2v1nf3t"
                },
                "var(--_1vqcj1iv)": {
                    defaultClass: "_1y2v1nf3u"
                },
                "var(--_1vqcj1iw)": {
                    defaultClass: "_1y2v1nf3v"
                },
                "var(--_1vqcj1ix)": {
                    defaultClass: "_1y2v1nf3w"
                },
                "var(--_1vqcj1iy)": {
                    defaultClass: "_1y2v1nf3x"
                },
                "var(--_1vqcj1iz)": {
                    defaultClass: "_1y2v1nf3y"
                },
                "var(--_1vqcj1i10)": {
                    defaultClass: "_1y2v1nf3z"
                },
                "var(--_1vqcj1i11)": {
                    defaultClass: "_1y2v1nf40"
                },
                "var(--_1vqcj1i12)": {
                    defaultClass: "_1y2v1nf41"
                },
                "var(--_1vqcj1i13)": {
                    defaultClass: "_1y2v1nf42"
                },
                "var(--_1vqcj1i14)": {
                    defaultClass: "_1y2v1nf43"
                },
                "var(--_1vqcj1i15)": {
                    defaultClass: "_1y2v1nf44"
                },
                "var(--_1vqcj1i16)": {
                    defaultClass: "_1y2v1nf45"
                },
                "var(--_1vqcj1i17)": {
                    defaultClass: "_1y2v1nf46"
                },
                "var(--_1vqcj1i18)": {
                    defaultClass: "_1y2v1nf47"
                },
                "var(--_1vqcj1i19)": {
                    defaultClass: "_1y2v1nf48"
                },
                "var(--_1vqcj1i1a)": {
                    defaultClass: "_1y2v1nf49"
                },
                "var(--_1vqcj1i1b)": {
                    defaultClass: "_1y2v1nf4a"
                },
                "var(--_1vqcj1i1c)": {
                    defaultClass: "_1y2v1nf4b"
                },
                "var(--_1vqcj1i1d)": {
                    defaultClass: "_1y2v1nf4c"
                },
                "var(--_1vqcj1i1e)": {
                    defaultClass: "_1y2v1nf4d"
                },
                "var(--_1vqcj1i1f)": {
                    defaultClass: "_1y2v1nf4e"
                },
                "var(--_1vqcj1i1g)": {
                    defaultClass: "_1y2v1nf4f"
                },
                "var(--_1vqcj1i1h)": {
                    defaultClass: "_1y2v1nf4g"
                },
                "var(--_1vqcj1i1i)": {
                    defaultClass: "_1y2v1nf4h"
                },
                "var(--_1vqcj1i1j)": {
                    defaultClass: "_1y2v1nf4i"
                },
                "var(--_1vqcj1i1k)": {
                    defaultClass: "_1y2v1nf4j"
                },
                "var(--_1vqcj1i1l)": {
                    defaultClass: "_1y2v1nf4k"
                },
                "var(--_1vqcj1i1m)": {
                    defaultClass: "_1y2v1nf4l"
                },
                "var(--_1vqcj1i1n)": {
                    defaultClass: "_1y2v1nf4m"
                },
                "var(--_1vqcj1i1o)": {
                    defaultClass: "_1y2v1nf4n"
                },
                "var(--_1vqcj1i1p)": {
                    defaultClass: "_1y2v1nf4o"
                },
                "var(--_1vqcj1i1q)": {
                    defaultClass: "_1y2v1nf4p"
                },
                "var(--_1vqcj1i1r)": {
                    defaultClass: "_1y2v1nf4q"
                },
                "var(--_1vqcj1i1s)": {
                    defaultClass: "_1y2v1nf4r"
                },
                "var(--_1vqcj1i1t)": {
                    defaultClass: "_1y2v1nf4s"
                },
                "var(--_1vqcj1i1u)": {
                    defaultClass: "_1y2v1nf4t"
                },
                "var(--_1vqcj1i1v)": {
                    defaultClass: "_1y2v1nf4u"
                },
                "var(--_1vqcj1i1w)": {
                    defaultClass: "_1y2v1nf4v"
                },
                "var(--_1vqcj1i1x)": {
                    defaultClass: "_1y2v1nf4w"
                },
                "var(--_1vqcj1i1y)": {
                    defaultClass: "_1y2v1nf4x"
                },
                "var(--_1vqcj1i1z)": {
                    defaultClass: "_1y2v1nf4y"
                },
                "var(--_1vqcj1i20)": {
                    defaultClass: "_1y2v1nf4z"
                },
                "var(--_1vqcj1i21)": {
                    defaultClass: "_1y2v1nf50"
                },
                "var(--_1vqcj1i22)": {
                    defaultClass: "_1y2v1nf51"
                },
                "var(--_1vqcj1i23)": {
                    defaultClass: "_1y2v1nf52"
                },
                "var(--_1vqcj1i24)": {
                    defaultClass: "_1y2v1nf53"
                },
                "var(--_1vqcj1i25)": {
                    defaultClass: "_1y2v1nf54"
                },
                "var(--_1vqcj1i26)": {
                    defaultClass: "_1y2v1nf55"
                },
                "var(--_1vqcj1i27)": {
                    defaultClass: "_1y2v1nf56"
                },
                "var(--_1vqcj1i28)": {
                    defaultClass: "_1y2v1nf57"
                },
                "var(--_1vqcj1i29)": {
                    defaultClass: "_1y2v1nf58"
                },
                "var(--_1vqcj1i2a)": {
                    defaultClass: "_1y2v1nf59"
                },
                "var(--_1vqcj1i2b)": {
                    defaultClass: "_1y2v1nf5a"
                },
                "var(--_1vqcj1i2c)": {
                    defaultClass: "_1y2v1nf5b"
                },
                "var(--_1vqcj1i2d)": {
                    defaultClass: "_1y2v1nf5c"
                },
                "var(--_1vqcj1i2e)": {
                    defaultClass: "_1y2v1nf5d"
                },
                "var(--_1vqcj1i2f)": {
                    defaultClass: "_1y2v1nf5e"
                },
                "var(--_1vqcj1i2g)": {
                    defaultClass: "_1y2v1nf5f"
                },
                "var(--_1vqcj1i2h)": {
                    defaultClass: "_1y2v1nf5g"
                },
                "var(--_1vqcj1i2i)": {
                    defaultClass: "_1y2v1nf5h"
                },
                "var(--_1vqcj1i2j)": {
                    defaultClass: "_1y2v1nf5i"
                },
                "var(--_1vqcj1i2k)": {
                    defaultClass: "_1y2v1nf5j"
                },
                "var(--_1vqcj1i2l)": {
                    defaultClass: "_1y2v1nf5k"
                },
                "var(--_1vqcj1i2m)": {
                    defaultClass: "_1y2v1nf5l"
                },
                "var(--_1vqcj1i2n)": {
                    defaultClass: "_1y2v1nf5m"
                },
                "var(--_1vqcj1i2o)": {
                    defaultClass: "_1y2v1nf5n"
                },
                "var(--_1vqcj1i2p)": {
                    defaultClass: "_1y2v1nf5o"
                },
                "var(--_1vqcj1i2q)": {
                    defaultClass: "_1y2v1nf5p"
                },
                "var(--_1vqcj1i2r)": {
                    defaultClass: "_1y2v1nf5q"
                },
                "var(--_1vqcj1i2s)": {
                    defaultClass: "_1y2v1nf5r"
                },
                "var(--_1vqcj1i2t)": {
                    defaultClass: "_1y2v1nf5s"
                },
                "var(--_1vqcj1i2u)": {
                    defaultClass: "_1y2v1nf5t"
                },
                "var(--_1vqcj1i2v)": {
                    defaultClass: "_1y2v1nf5u"
                },
                "var(--_1vqcj1i2w)": {
                    defaultClass: "_1y2v1nf5v"
                },
                transparent: {
                    defaultClass: "_1y2v1nf5y"
                },
                inherit: {
                    defaultClass: "_1y2v1nf5x"
                }
            }
        }
    }
});
export { s as sprinkles };
